import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Card, CardActions, CardContent, Divider, Icon, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { TravelClubPlan } from '../../../../domain/travel-club';

// ********************************************************************************
type Props = {
  traveClubPlan: TravelClubPlan;
  action?: () => void;
};
export const TravelClubCard = ({ traveClubPlan, action }: Props) => {
  const { t } = useTranslation();
  const planT = (key: string) => t(`travel_club_service.plans.${traveClubPlan.key}.${key}`);
  const properties = t(`travel_club_service.plans.${traveClubPlan.key}.properties`, {
    returnObjects: true,
  }) as string[];

  // == Render =====================================================================
  return (
    <Card
      sx={{
        flex: 1,
        maxWidth: '368px',
        height: { xs: 'auto', sm: '476px' },
        minHeight: '476px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <CardContent>
        <Stack sx={{ height: { xs: 'auto', sm: '55px' } }}>
          <Box display="flex" flexWrap="wrap" justifyContent="space-between" alignItems="center" gap={1}>
            <Typography variant="h3" color="#3F2B56" fontFamily="Gotham-Bold" fontSize="24px" align="center">
              {planT('title')}
            </Typography>
            <Box bgcolor="#F7F7F7" px={2} py={1} borderRadius="8px">
              <Typography variant="h4" color="#3F2B56" fontFamily="Gotham-Bold" fontSize="16px" align="center">
                {t('travel_club_service.plans.coming_soon')}
              </Typography>
            </Box>
          </Box>
          {traveClubPlan.recurring && (
            <Typography variant="body1" color="#606E79" fontSize="16px" lineHeight="19.2px" mt={1}>
              {t('travel_club_service.plans.recurring_payment')}
            </Typography>
          )}
        </Stack>
        <Divider sx={{ mt: 3, mb: 6 }} />
        <Stack spacing={2} pr={2}>
          {Array.isArray(properties) &&
            properties.map((property, index) => (
              <Stack key={index} direction="row" spacing={1} alignItems="center">
                <Icon component={CheckCircleIcon} sx={{ color: '#3F2B56', fontSize: '24px' }} />

                <Typography component="span" fontSize="14px" lineHeight="16.8px" color="#302F2F">
                  <Trans
                    i18nKey={property}
                    components={[<Typography fontFamily="Gotham-Medium" fontSize="14px" lineHeight="16.8px" />]}
                  />
                </Typography>
              </Stack>
            ))}
        </Stack>
      </CardContent>
      {action && (
        <CardActions sx={{ px: 2, py: 2 }}>
          <Button
            // @ts-ignore
            variant="grey"
            fullWidth
            onClick={action}
            sx={{ borderRadius: '4px', fontFamily: 'Gotham-Bold', fontSize: '12px' }}
          >
            {planT('button')}
          </Button>
        </CardActions>
      )}
    </Card>
  );
};
